// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1C0Er","container":"_3QC39","verticalSeparator":"bxCRi","horizontalSeparator":"_2K5kg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/promote-moderator-modal/promote-moderator-modal.scss
// module id = 907
// module chunks = 3 4 5 6 7